module.exports = __webpack_public_path__ + "static/media/ButtonWithoutBorder.c87c9d71.svg";